import { TestUniformPage } from "src/pages/test-uniform/test-uniform-page";

import { init } from "../init";
init(TestUniformPage);
